import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as api from "../../../redux/api";
import { reactIcons } from "../../../utils/icons";
import CustomFileInput from "../../CustomFileInput";

const RiskAssessment = () => {
  const [form, setForm] = useState({
    hasLegalSanctions: false,
    legalSanctionDetails: "",
    amlCftPolicies: "",
    complianceOfficerName: "",
    complianceOfficerPosition: "",
    staffTrainingDetails: "",
    isNotApplicable: false
  });

  const [documentTypes, setDocumentTypes] = useState({
    amlCftPolicyDocument: [],
    internalAuditReports: []
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [status, setStatus] = useState([]);

  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const { key } = location.state || {};
  console.log("keyrisk", key);

  const getData = async () => {
    try {
      if (!id) return;
      const res = await api.getUserList(id);
      if (res.status && res.data) {
        const complianceRiskAssessment =
          res?.data?.data?.ComplianceRiskAssessment?.[0];
        setStatus(res.data);
        if (complianceRiskAssessment) {
          setIsReadOnly(true);
          setForm({
            hasLegalSanctions:
              complianceRiskAssessment.hasLegalSanctions || false,
            legalSanctionDetails:
              complianceRiskAssessment.legalSanctionDetails || "",
            amlCftPolicies: complianceRiskAssessment.amlCftPolicies || "",
            complianceOfficerName:
              complianceRiskAssessment.complianceOfficerName || "",
            complianceOfficerPosition:
              complianceRiskAssessment.complianceOfficerPosition || "",
            staffTrainingDetails:
              complianceRiskAssessment.staffTrainingDetails || "",
            isNotApplicable: complianceRiskAssessment.isNotApplicable || false
          });

          const amlDocs = complianceRiskAssessment.amlCftPolicyDocument || [];
          const auditDocs = complianceRiskAssessment.internalAuditReports || [];
          setDocumentTypes({
            amlCftPolicyDocument: amlDocs.map((url) => ({
              name: url.split("/").pop(),
              url
            })),
            internalAuditReports: auditDocs.map((url) => ({
              name: url.split("/").pop(),
              url
            }))
          });
        }
      } else {
        console.error("Error fetching data:", res.message);
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };
  console.log("datacheck", status?.data?.adminId);
  console.log("datachecka", status);
  const rout = status?.data?.adminId;
  useEffect(() => {
    if (id) {
      getData();
    }
    // eslint-disable-next-line
  }, [id]);

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    if (type === "checkbox") {
      setForm((prev) => ({ ...prev, [name]: e.target.checked }));
    } else if (name === "hasLegalSanctions") {
      setForm((prev) => ({ ...prev, [name]: value === "true" }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: checked }));
  };

  const validateForm = () => {
    const errors = {};

    if (form.hasLegalSanctions && !form.legalSanctionDetails.trim()) {
      errors.legalSanctionDetails = "This field is required";
    }
    if (!form.isNotApplicable) {
      if (!form.amlCftPolicies.trim()) {
        errors.amlCftPolicies = "AML/CFT Policies are required";
      }
      if (!form.staffTrainingDetails.trim()) {
        errors.staffTrainingDetails = "Staff training details are required";
      }
      if (!form.complianceOfficerName.trim()) {
        errors.complianceOfficerName = "Officer name is required";
      }
      if (!form.complianceOfficerPosition.trim()) {
        errors.complianceOfficerPosition = "Officer position is required";
      }
      if (documentTypes.amlCftPolicyDocument.length === 0) {
        errors.amlCftPolicyDocument =
          "Upload at least one AML/CFT Policy Document";
      }
      if (documentTypes.internalAuditReports.length === 0) {
        errors.internalAuditReports = "Upload at least one Audit Report";
      }
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;
    if (!validateForm()) {
      toast.error("Please fix validation errors");
      return;
    }

    try {
      setIsLoading(true);

      const riskAssessment = {
        hasLegalSanctions: form.hasLegalSanctions,
        organizationId: Number(id),
        isNotApplicable: form.isNotApplicable
      };

      if (form.hasLegalSanctions) {
        riskAssessment.legalSanctionDetails = form.legalSanctionDetails;
      }

      if (!form.isNotApplicable) {
        riskAssessment.amlCftPolicies = form.amlCftPolicies;
        riskAssessment.complianceOfficerName = form.complianceOfficerName;
        riskAssessment.complianceOfficerPosition =
          form.complianceOfficerPosition;
        riskAssessment.staffTrainingDetails = form.staffTrainingDetails;
      }
      riskAssessment.amlCftPolicyDocument =
        documentTypes.amlCftPolicyDocument.map((doc) => doc.url);
      riskAssessment.internalAuditReports =
        documentTypes.internalAuditReports.map((doc) => doc.url);
      const payload = {
        complianceRiskAssessments: [riskAssessment]
      };

      const res = await api.riskAssesment(payload);
      if (res.status === 200 || res.status === 201) {
        toast.success("Data added successfully");
        navigate(`/admin-kyc/${id}`, { state: { key } });
      } else {
        toast.error(res?.error?.message || "Submission failed");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "An error occurred while submitting the form"
      );
    } finally {
      setIsLoading(false);
    }
  };
  const updateDocuments = (field, urls) => {
    const files = urls.map((url) => ({
      name: url.split("/").pop(),
      url
    }));
    setDocumentTypes((prev) => ({
      ...prev,
      [field]: files
    }));

    setFormErrors((prev) => ({
      ...prev,
      [field]: null
    }));
  };

  return (
    <div>
      <h2 className="text-black text-24 text-center pb-10">Risk Assessment</h2>

      <form
        className="grid grid-cols-2 gap-4 items-start border mt-5 border-yellow-dark p-5 rounded-[10px]"
        onSubmit={(e) => {
          e.preventDefault();
          if (key) {
            handleSubmit(e);
          } else if (id) {
            if (rout === null) {
              navigate(`/acknowledgment/${id}`);
            } else {
              navigate(`/admin-kyc/${id}`);
            }
          } else {
            handleSubmit(e);
          }
        }}
      >
        <div className="col-span-1 space-y-2">
          <label className="text-black">
            Has your organization been subject to any legal sanctions or
            penalties?
          </label>
          <select
            name="hasLegalSanctions"
            value={form.hasLegalSanctions ? "true" : "false"}
            onChange={handleChange}
            disabled={isReadOnly}
            className={`text-input ${isReadOnly ? "readonly-input" : ""}`}
          >
            <option value="false">No</option>
            <option value="true">Yes</option>
          </select>
        </div>

        {form.hasLegalSanctions && (
          <div className="col-span-1 space-y-2">
            <label className="text-black">
              Legal Sanctions Details <span className="text-red-600">*</span>
            </label>
            <textarea
              name="legalSanctionDetails"
              value={form.legalSanctionDetails}
              onChange={handleChange}
              placeholder="Provide details of legal sanctions"
              readOnly={isReadOnly}
              className={`text-area ${
                isReadOnly ? "bg-gray-100 cursor-not-allowed" : ""
              }`}
            />
            {formErrors.legalSanctionDetails && (
              <p className="text-red-500 text-sm">
                {formErrors.legalSanctionDetails}
              </p>
            )}
          </div>
        )}

        <div className="col-span-1 flex items-center gap-2 mt-10">
          <input
            type="checkbox"
            name="isNotApplicable"
            checked={form.isNotApplicable}
            onChange={handleCheckboxChange}
            disabled={isReadOnly}
            className="w-5 h-5 "
          />
          <label className="text-black">
            N/A: Check this box if this section does not apply to your entity.
          </label>
        </div>

        {!form.isNotApplicable && (
          <>
            <div className="col-span-1 space-y-2">
              <label className="text-black">
                AML/CFT Policies <span className="text-red-600">*</span>
              </label>
              <textarea
                name="amlCftPolicies"
                value={form.amlCftPolicies}
                onChange={handleChange}
                placeholder="Summarize AML/CFT measures"
                readOnly={isReadOnly}
                className={`text-area ${
                  isReadOnly ? "bg-gray-100 cursor-not-allowed" : ""
                }`}
              />
              {formErrors.amlCftPolicies && (
                <p className="text-red-500 text-sm">
                  {formErrors.amlCftPolicies}
                </p>
              )}
            </div>

            <div className="col-span-1 space-y-2">
              <label className="text-black">
                Training Programs for Staff{" "}
                <span className="text-red-600">*</span>
              </label>
              <textarea
                name="staffTrainingDetails"
                value={form.staffTrainingDetails}
                onChange={handleChange}
                placeholder="Outline staff training initiatives"
                readOnly={isReadOnly}
                className={`text-area ${
                  isReadOnly ? "bg-gray-100 cursor-not-allowed" : ""
                }`}
              />
              {formErrors.staffTrainingDetails && (
                <p className="text-red-500 text-sm">
                  {formErrors.staffTrainingDetails}
                </p>
              )}
            </div>

            <div className="col-span-1 space-y-2">
              <label className="text-black">
                Compliance Officer Name <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                name="complianceOfficerName"
                value={form.complianceOfficerName}
                onChange={handleChange}
                placeholder="Enter name"
                readOnly={isReadOnly}
                className={`text-input ${isReadOnly ? "readonly-input" : ""}`}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                }}
                maxLength={50}
              />
              {formErrors.complianceOfficerName && (
                <p className="text-red-500 text-sm">
                  {formErrors.complianceOfficerName}
                </p>
              )}
            </div>

            <div className="col-span-1 space-y-2">
              <label className="text-black">
                Compliance Officer Position{" "}
                <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                name="complianceOfficerPosition"
                value={form.complianceOfficerPosition}
                onChange={handleChange}
                placeholder="Enter position"
                readOnly={isReadOnly}
                className={`text-input ${isReadOnly ? "readonly-input" : ""}`}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                }}
                maxLength={50}
              />
              {formErrors.complianceOfficerPosition && (
                <p className="text-red-500 text-sm">
                  {formErrors.complianceOfficerPosition}
                </p>
              )}
            </div>
          </>
        )}

        <div className="col-span-1">
          <label className="text-black">
            AML/CFT Policy Document <span className="text-red-600">*</span>
          </label>

          <CustomFileInput
            allowedFormats=" PDF"
            name="amlCftPolicyDocument"
            defaultValue={documentTypes.amlCftPolicyDocument.map((d) => d.url)}
            onChange={(urls) => updateDocuments("amlCftPolicyDocument", urls)}
            disabled={isReadOnly}
          />
          {formErrors.amlCftPolicyDocument && (
            <p className="text-red-500 text-sm">
              {formErrors.amlCftPolicyDocument}
            </p>
          )}
        </div>

        <div className="col-span-1">
          <label className="text-black">
            Internal Audit Reports (Last 1 Year){" "}
            <span className="text-red-600">*</span>
          </label>

          <CustomFileInput
            allowedFormats=" PDF"
            name="internalAuditReports"
            defaultValue={documentTypes.internalAuditReports.map((d) => d.url)}
            onChange={(urls) => updateDocuments("internalAuditReports", urls)}
            disabled={isReadOnly}
          />
          {formErrors.internalAuditReports && (
            <p className="text-red-500 text-sm">
              {formErrors.internalAuditReports}
            </p>
          )}
        </div>

        <div className="col-span-2 flex justify-between items-center">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="btn btn-danger"
          >
            {reactIcons.arrowleft} Back
          </button>
          <button
            type="submit"
            disabled={isLoading}
            className="py-3 px-6 rounded btn-primary flex items-center"
          >
            Next {reactIcons.arrowright}
          </button>
        </div>
      </form>
    </div>
  );
};

export default RiskAssessment;
